import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { PaginationType, QueryType } from 'GLOBAL_TYPES';
import prevImg from "assets/images/i37.svg";
import nextImg from "assets/images/i38.svg";

const propTypes = {
  pagination: PaginationType,
  query: QueryType,
  location: PropTypes.object
};

class Pagination extends React.PureComponent {
  render() {
    const { pagination, query, location } = this.props;
    const show = pagination.limit > 1;

    const prevLink = {
      search: query.stringify({ page: pagination.prev }),
      state: location ? location.state : undefined
    };

    const nextLink = {
      search: query.stringify({ page: pagination.next }),
      state: location ? location.state : undefined
    };

    const prevDisabled = pagination.prev === null;
    const nextDisabled = pagination.next === null;

    const prevDisabledClass = prevDisabled ? 'page-link-disable' : '';
    const nextDisabledClass = nextDisabled ? 'page-link-disable' : '';

    const PrevTag = prevDisabled ? 'span' : Link;
    const NextTag = nextDisabled ? 'span' : Link;

    return (
      <div className="pagination">
        {show === true && (
          <Fragment>
            <div className="page-counter">
              <strong>{pagination.page}</strong>
              <span>/{pagination.limit}</span>
            </div>
            <div className="pagination-icons">
              <PrevTag replace={prevDisabled ? '' : true} to={prevLink} title="poprzednia" className={`page-prev ${prevDisabledClass}`}>
                <img src={prevImg} alt="" />
              </PrevTag>
              <NextTag replace={nextDisabled ? '' : true} to={nextLink} title="następna" className={`page-next ${nextDisabledClass}`}>
                <img src={nextImg} alt="" />
              </NextTag>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

Pagination.propTypes = propTypes;

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/ui/Pagination.jsx